// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2WyLB","col":"CardReaderDesc_col__mDaPp","label":"CardReaderDesc_label__3QfWt"};